// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.task-stats-widget {
  z-index: 2;
}
.task-stats-widget .widget-header {
  font-size: 1.4rem;
  margin-bottom: 20px;
}
.task-stats-widget .widget-header .widget-title {
  font-size: 1.25rem;
  margin-bottom: 1.5rempx;
  font-weight: 600;
  color: #1e293b;
  text-align: center;
}
.task-stats-widget .widget-header .tab-container {
  display: flex;
  background: #f1f5f9;
  border-radius: 6px;
  padding: 2px;
  gap: 2px;
}
.task-stats-widget .widget-header .tab-container .tab-button {
  padding: 12px 8px;
  width: 50%;
  border: none;
  border-radius: 4px;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  background: transparent;
  color: #64748b;
  transition: all 0.2s;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
.task-stats-widget .widget-header .tab-container .tab-button:hover {
  background: #e2e8f0;
}
.task-stats-widget .widget-header .tab-container .tab-button.active {
  background-color: var(--primary-color);
  color: white;
}
.task-stats-widget .widget-content .chart-container {
  border-radius: 6px;
  padding: 12px;
  text-align: center;
}
.task-stats-widget .widget-content .chart-container .chart-title {
  font-size: 14px;
  font-weight: 600;
  color: #1e293b;
  margin: 0 0 8px 0;
}
.task-stats-widget .widget-content .chart-container .total-tasks {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: rgba(79, 70, 229, 0.1);
  padding: 4px 12px;
  border-radius: 12px;
  margin-bottom: 8px;
}
.task-stats-widget .widget-content .chart-container .total-tasks .total-label {
  font-size: 12px;
  font-weight: 500;
  color: #64748b;
}
.task-stats-widget .widget-content .chart-container .total-tasks .total-number {
  font-size: 14px;
  font-weight: 600;
  color: var(--primary-color);
}
.task-stats-widget .widget-content .no-data {
  text-align: center;
  padding: 20px;
  color: #94a3b8;
  background: #f8fafc;
  border-radius: 6px;
}
.task-stats-widget .widget-content .no-data .no-data-icon {
  font-size: 24px;
  margin-bottom: 8px;
  opacity: 0.6;
}
.task-stats-widget .widget-content .no-data p {
  margin: 0;
  font-size: 12px;
  font-weight: 500;
}

.stat-tooltip-label {
  color: white;
  padding: 0.5rem 0.75rem;
  background-color: #1e293b;
}

@media (max-width: 480px) {
  .task-stats-widget {
    max-width: 280px;
    padding: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TaskStatsWidget/TaskStatsWidget.scss"],"names":[],"mappings":"AAAA;EACI,UAAA;AACJ;AAAI;EACI,iBAAA;EACA,mBAAA;AAER;AAAQ;EACI,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAEZ;AACQ;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;AACZ;AACY;EAEI,iBAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;AAAhB;AAEgB;EACI,mBAAA;AAApB;AAGgB;EACI,sCAAA;EACA,YAAA;AADpB;AAQQ;EACI,kBAAA;EACA,aAAA;EACA,kBAAA;AANZ;AAQY;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AANhB;AASY;EACI,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kCAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;AAPhB;AASgB;EACI,eAAA;EACA,gBAAA;EACA,cAAA;AAPpB;AAUgB;EACI,eAAA;EACA,gBAAA;EACA,2BAAA;AARpB;AAaQ;EACI,kBAAA;EACA,aAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAXZ;AAaY;EACI,eAAA;EACA,kBAAA;EACA,YAAA;AAXhB;AAcY;EACI,SAAA;EACA,eAAA;EACA,gBAAA;AAZhB;;AAkBA;EACI,YAAA;EACA,uBAAA;EACA,yBAAA;AAfJ;;AAmBA;EACI;IACI,gBAAA;IACA,aAAA;EAhBN;AACF","sourcesContent":[".task-stats-widget {\n    z-index: 2;\n    .widget-header {\n        font-size: 1.4rem;\n        margin-bottom: 20px;\n\n        .widget-title {\n            font-size: 1.25rem;\n            margin-bottom: 1.5rempx;\n            font-weight: 600;\n            color: #1e293b;\n            text-align: center;\n        }\n\n        .tab-container {\n            display: flex;\n            background: #f1f5f9;\n            border-radius: 6px;\n            padding: 2px;\n            gap: 2px;\n\n            .tab-button {\n                // flex: 1;\n                padding: 12px 8px;\n                width: 50%;\n                border: none;\n                border-radius: 4px;\n                font-weight: 500;\n                font-size: 14px;\n                cursor: pointer;\n                background: transparent;\n                color: #64748b;\n                transition: all 0.2s;\n                display: flex;\n                justify-content: center;\n                align-items: center;\n                gap: 5px;\n\n                &:hover {\n                    background: #e2e8f0;\n                }\n\n                &.active {\n                    background-color: var(--primary-color);\n                    color: white;\n                }\n            }\n        }\n    }\n\n    .widget-content {\n        .chart-container {\n            border-radius: 6px;\n            padding: 12px;\n            text-align: center;\n\n            .chart-title {\n                font-size: 14px;\n                font-weight: 600;\n                color: #1e293b;\n                margin: 0 0 8px 0;\n            }\n\n            .total-tasks {\n                display: inline-flex;\n                align-items: center;\n                gap: 4px;\n                background: rgba(79, 70, 229, 0.1);\n                padding: 4px 12px;\n                border-radius: 12px;\n                margin-bottom: 8px;\n\n                .total-label {\n                    font-size: 12px;\n                    font-weight: 500;\n                    color: #64748b;\n                }\n\n                .total-number {\n                    font-size: 14px;\n                    font-weight: 600;\n                    color: var(--primary-color);\n                }\n            }\n        }\n\n        .no-data {\n            text-align: center;\n            padding: 20px;\n            color: #94a3b8;\n            background: #f8fafc;\n            border-radius: 6px;\n\n            .no-data-icon {\n                font-size: 24px;\n                margin-bottom: 8px;\n                opacity: 0.6;\n            }\n\n            p {\n                margin: 0;\n                font-size: 12px;\n                font-weight: 500;\n            }\n        }\n    }\n}\n\n.stat-tooltip-label {\n    color: white;\n    padding: 0.5rem 0.75rem;\n    background-color: #1e293b;\n}\n\n// Mobile\n@media (max-width: 480px) {\n    .task-stats-widget {\n        max-width: 280px;\n        padding: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
